/**
 * WorkoutNumberStepper 纯函数：便于单测与组件共用，避免逻辑漂移。
 */

export const STEP_BLUR_GUARD_MS = 200

/**
 * 编辑中的半成品数字（如 "3." / ""），此时只保留 draft、不要 emit，
 * 否则父级回写 + toFixed 会把小数点吃掉，输入 3.5 / 15 会跳成 3.0、1.0。
 */
export function isIncompleteNumericDraft(raw) {
  if (raw == null) {
    return true
  }
  const text = String(raw).trim()
  if (text === '' || text === '-' || text === '+' || text === '.') {
    return true
  }
  return text.endsWith('.')
}

export function coerceStepperValue(value, precision) {
  if (value === '' || value == null) {
    return null
  }
  const direct = Number(value)
  if (Number.isFinite(direct)) {
    return direct
  }
  const parsed = precision > 0 ? Number.parseFloat(value) : Number.parseInt(value, 10)
  return Number.isFinite(parsed) ? parsed : null
}

export function roundStepperValue(parsed, precision, min) {
  if (!Number.isFinite(parsed)) {
    return min
  }
  if (precision > 0) {
    const factor = 10 ** precision
    return Math.round(parsed * factor) / factor
  }
  return Math.round(parsed)
}

export function clampStepperValue(raw, { min, max, precision }) {
  const coerced = coerceStepperValue(raw, precision)
  if (coerced == null) {
    return min
  }
  const ceiling = Number.isFinite(max) && max > min ? max : Infinity
  return Math.min(ceiling, Math.max(min, roundStepperValue(coerced, precision, min)))
}

export function computeSteppedValue(value, { min, max, step, precision, delta }) {
  const coerced = coerceStepperValue(value, precision)
  const base = coerced == null ? min : coerced
  const stepped = roundStepperValue(base + delta * step, precision, min)
  return clampStepperValue(stepped, { min, max, precision })
}

export function isAtMin(value, min, precision) {
  const coerced = coerceStepperValue(value, precision)
  const numeric = coerced == null ? min : coerced
  return numeric <= min
}

/** 仅当 prop max 有意义（max > min）时才禁用 +；max=0 且 value>0 视为父层未同步，仍允许步进。 */
export function isAtMax(value, min, max, precision) {
  if (!Number.isFinite(max)) {
    return false
  }
  const coerced = coerceStepperValue(value, precision)
  const numeric = coerced == null ? min : coerced
  if (max <= min) {
    return numeric <= min
  }
  return numeric >= max
}

export function inputWithinBounds(parsed, min, max) {
  if (parsed < min) {
    return false
  }
  if (!Number.isFinite(max) || max <= min) {
    return true
  }
  return parsed <= max
}

export function formatStepperInputText(value, precision, draftText) {
  if (draftText != null) {
    return draftText
  }
  const coerced = coerceStepperValue(value, precision)
  if (coerced == null) {
    return ''
  }
  if (precision > 0) {
    return coerced.toFixed(precision)
  }
  return String(coerced)
}
